import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { usePushSubscription } from '../../../../redux/pwa/hooks';
import { isPWA } from '../../../../utils/isPWA';
import SuffixText from '../_partials/SuffixText';
export function usePushSubscriptionItem() {
    const pwa = useFlag('pwa');
    const { register, isSubscribed, isBlocked, manage } = usePushSubscription();
    const { t } = useTranslation();
    // Only show the PWA menu item on if we're running in PWA mode
    if (!isPWA()) {
        return false;
    }
    return pwa && {
        label: t('siteHeader.userMenu.pwa.loggedIn.label'),
        suffix: /*#__PURE__*/ React.createElement(SuffixText, null, isBlocked ? t('siteHeader.userMenu.pwa.loggedIn.suffix.blocked') : isSubscribed ? t('siteHeader.userMenu.pwa.loggedIn.suffix.enabled') : t('siteHeader.userMenu.pwa.loggedIn.suffix.disabled')),
        onClick: isBlocked || isSubscribed ? manage : register
    };
}

//# sourceMappingURL=usePushSubscriptionItem.js.map